/// Menu
import MetisMenu from "metismenujs";
import React, { Fragment, Component } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { restaurantHasQRpay } from '../../common/utils';
import { withRouter } from 'react-router-dom';
import indexedDBService from '../../../services/IndexedDBService';

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }

  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

async function getUserRole() {
  let userDetails = await indexedDBService.getUserData('userDetails');
  if (userDetails) {
    return userDetails.userData.role
  } else {
    return null
  }
}

async function getRestaurantsFromLocalStorage() {
  let userDetails = await indexedDBService.getUserData('userDetails');
  return userDetails.restaurants
}

async function getRestaurantFromLocalStorage() {
  let userDetails = await indexedDBService.getUserData('userDetails');
  if (!!userDetails && !!userDetails.idToken) {
    return userDetails.restaurant
  } else {
    return false;
  }
}

async function saveRestaurantToLocalStorage(restaurant) {
  let userDetails = await indexedDBService.getUserData('userDetails');
  userDetails.restaurant = restaurant;
  await indexedDBService.setUserData('userDetails', userDetails);
  window.location.reload();
}

function settings() {
  return { general: 'Основні', services: 'Послуги', menu: 'Меню', sales: 'Акції', schedule: 'Графік', tables: 'QR коди', stuff: 'Персонал', competitors: 'Конкуренти' }
}

class SideBar extends Component {
  constructor(props) {
    super(props);

    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.state = {
      userData: null,
      restaurants: [],
      currentRestaurant: null,
      userRole: null,
    }
  }

  async componentDidMount() {
    try {
      const userDetails = await indexedDBService.getUserData('userDetails');
      if (userDetails) {
        this.setState({
          userData: userDetails,
          userRole: userDetails.userData?.role,
          restaurants: userDetails.restaurants || [],
          currentRestaurant: userDetails.restaurant
        });
      }
    } catch (error) {
      console.error('Failed to load user data:', error);
    }

    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    let btn = document.querySelector(".nav-control");
    if (!!this.wrapperRef.current && !this.wrapperRef.current.contains(event.target) && !btn.contains(event.target)) {
      let aaa = document.querySelector("#main-wrapper");
      let close = document.querySelector("#sidebar-close");
      aaa.classList.remove("menu-toggle");
      close.classList.remove('sidebar-close');
      const hasOpenModal = document.querySelector('.modal.show') || document.querySelector('[data-rsbs-overlay]');
      if (!hasOpenModal) {
        window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'BOTTOM_SHEET', open: false }));
      }
    }
  };

  async saveRestaurantToLocalStorage(restaurant) {
    try {
      let userDetails = await indexedDBService.getUserData('userDetails');
      userDetails.restaurant = restaurant;
      await indexedDBService.setUserData('userDetails', userDetails);
      this.setState({ currentRestaurant: restaurant });
      window.location.reload();
    } catch (error) {
      console.error('Failed to save restaurant:', error);
    }
  }

  closeSideBar = () => {
    const aaa = document.querySelector("#main-wrapper");
    const close = document.querySelector("#sidebar-close");
    aaa.classList.remove("menu-toggle");
    close.classList.remove('sidebar-close');
  };

  render() {
    const { userData, restaurants, currentRestaurant, userRole } = this.state;
    const { history } = this.props;

    if (!userData) {
      return null;
    }

    const isWorker = !!currentRestaurant && !!currentRestaurant.management_roles &&
      currentRestaurant.management_roles.role === 'worker';

    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];

    return (
      <div>
        <div className='sidebar-all'>
          <div id='sidebar-close' />
          <div className="deznav" ref={this.wrapperRef}>
            <PerfectScrollbar className="deznav-scroll">
              <MM className="metismenu" id="menu">
                {(userRole === 'admin' || userRole === 'manager') &&
                  <>
                    {!!currentRestaurant &&
                      <>
                        <li>
                          <a className='has-arrow ai-icon mm-active d-flex align-items-center py-0 pl-1' href="#">
                            <span className='menu-icon'>{String.fromCodePoint('0x1F3EC')}</span>
                            <span className="nav-text"><b>{currentRestaurant.name}</b></span>
                          </a>
                          <ul>
                            {restaurants.map((r, i) =>
                              <Fragment key={i}>
                                <li className={`${currentRestaurant.slug === r.slug ? "mm-active" : ""}`}
                                  onClick={() => this.saveRestaurantToLocalStorage(r)}>
                                  <Link to={window.location.pathname}
                                    className={`${currentRestaurant.slug === r.slug ? "mm-active" : ""}`}>
                                    <span className="nav-text"><b>{r.name}</b></span>
                                  </Link>
                                </li>
                              </Fragment>)}
                          </ul>
                        </li>
                        <li>
                          <a className={`${Object.keys(settings()).includes(window.location.pathname.split('/')[1]) && "mm-active"} has-arrow ai-icon d-flex align-items-center py-0 pl-1`} href="#">
                            <span className='menu-icon'>{String.fromCodePoint('0x2699')}</span>
                            <span className="nav-text">Налаштування</span>
                          </a>
                          <ul>
                            {Object.keys(settings()).map((r, i) =>
                              <Fragment key={i}>
                                <li className={`${window.location.pathname.includes(r) ? "mm-active" : ""}`}
                                  onClick={this.closeSideBar}
                                >
                                  <Link to={`/settings/${r}`}
                                    className={`${window.location.pathname.includes(r) ? "mm-active" : ""}`}>
                                    <span className="nav-text">{settings()[r]}</span>
                                  </Link>
                                </li>
                              </Fragment>)}
                          </ul>
                        </li>
                        <li onClick={this.closeSideBar} className={`${path === "dashboard" ? "mm-active" : ""}`}>
                          <Link className={`d-flex align-items-center py-0 pl-1 ${path === "dashboard" ? "mm-active" : ""}`}
                            onClick={() => this.props.onClick()} to="/dashboard"
                          >
                            <span className='menu-icon'>
                              {String.fromCodePoint('0x1F4CA')}
                            </span>
                            <span className="nav-text">Панель замовлень</span>
                          </Link>
                        </li>
                        <li onClick={this.closeSideBar} className={`${path === "restaurant-orders" ? "mm-active" : ""}`}>
                          <Link className={`d-flex align-items-center py-0 pl-1 ${path === "restaurant-orders" ? "mm-active" : ""}`}
                            onClick={() => this.props.onClick()} to="/restaurant-orders"
                          >
                            <span className='menu-icon'>
                              {String.fromCodePoint('0x1F5C3')}
                            </span>
                            <span className="nav-text">Архів замовлень</span>
                          </Link>
                        </li>
                        {restaurantHasQRpay() &&
                          <li onClick={this.closeSideBar} className={`${path === "paychecks" ? "mm-active" : ""}`}>
                            <Link className={`d-flex align-items-center py-0 pl-1 ${path === "paychecks" ? "mm-active" : ""}`}
                              onClick={() => this.props.onClick()} to="/paychecks"
                            >
                              <span className='menu-icon'>
                                {String.fromCodePoint('0x1F9FE')}
                              </span>
                              <span className="nav-text">Рахунки/оплата</span>
                            </Link>
                          </li>}
                        <li onClick={this.closeSideBar} className={`${path === "stop_list" && "mm-active"}`}>
                          <Link className={`d-flex align-items-center py-0 pl-1 ${path === "stop_list" && "mm-active"}`}
                            onClick={() => this.props.onClick()} to="/stop_list"
                          >
                            <span className='menu-icon'>
                              {String.fromCodePoint('0x1F6AB')}
                            </span>
                            <span className="nav-text">Стоп-лист</span>
                          </Link>
                        </li>
                        <li onClick={this.closeSideBar} className={`${path === "analytics" && "mm-active"}`}>
                          <Link className={`d-flex align-items-center py-0 pl-1 ${path === "analytics" && "mm-active"}`}
                            onClick={() => this.props.onClick()} to="/analytics"
                          >
                            <span className='menu-icon'>
                              {String.fromCodePoint('0x1F4C8')}
                            </span>
                            <span className="nav-text">Аналітика</span>
                          </Link>
                        </li>
                        <li onClick={this.closeSideBar} className={`${path === "restaurant_guests" && "mm-active"}`}>
                          <Link className={`d-flex align-items-center py-0 pl-1 ${path === "restaurant_guests" && "mm-active"}`}
                            onClick={() => this.props.onClick()} to="/restaurant_guests"
                          >
                            <span className='menu-icon'>
                              {String.fromCodePoint('0x1F46B')}
                            </span>
                            <span className="nav-text">База гостей</span>
                          </Link>
                        </li>
                        {currentRestaurant && Object.values(currentRestaurant.tables).filter((t) => t.is_terminal).length > 0 &&
                          <li onClick={this.closeSideBar} className={`${path === "kiosk" && "mm-active"}`}>
                            <Link className={`d-flex align-items-center py-0 pl-1 ${path === "kiosk" && "mm-active"}`}
                              onClick={() => this.props.onClick()} to="/kiosk"
                            >
                              <span className='menu-icon'>
                                {String.fromCodePoint('0x1F4F1')}
                              </span>
                              <span className="nav-text">Кіоск</span>
                            </Link>
                          </li>}
                      </>}
                    <li onClick={this.closeSideBar} className={`${path === "manager_orders" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "manager_orders" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/manager_orders"
                      >
                        <span className='menu-icon'>🛍️</span>
                        <span className="nav-text">Замовлення</span>
                      </Link>
                    </li>
                    <li onClick={this.closeSideBar} className={`${path === "deliveries" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "deliveries" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/deliveries"
                      >
                        <span className='menu-icon'>
                          {String.fromCodePoint('0x1F695')}
                        </span>
                        <span className="nav-text">Поїздки</span>
                      </Link>
                    </li>
                    <li onClick={this.closeSideBar} className={`${path === "my-deliveries" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "my-deliveries" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/my-deliveries"
                      >
                        <span className='menu-icon'>
                          {String.fromCodePoint('0x1F5C3')}
                        </span>
                        <span className="nav-text">Мої поїздки</span>
                      </Link>
                    </li>
                    {userRole === 'admin' &&
                      <li onClick={this.closeSideBar} className={`${path === "admin-carpools" ? "mm-active" : ""}`}>
                        <Link className={`d-flex align-items-center py-0 pl-1 ${path === "admin-carpools" ? "mm-active" : ""}`}
                          onClick={() => this.props.onClick()} to="/admin-carpools"
                        >
                          <span className='menu-icon'>🚗</span>
                          <span className="nav-text">Попутки</span>
                        </Link>
                      </li>
                    }
                    {userRole === 'admin' &&
                      <li onClick={this.closeSideBar} className={`${path === "admin-invoices" ? "mm-active" : ""}`}>
                        <Link className={`d-flex align-items-center py-0 pl-1 ${path === "admin-invoices" ? "mm-active" : ""}`}
                          onClick={() => this.props.onClick()} to="/admin-invoices"
                        >
                          <span className='menu-icon'>🧾</span>
                          <span className="nav-text">Рахунки</span>
                        </Link>
                      </li>
                    }
                    {(userRole === 'admin' || userRole === 'manager' || userRole === 'telegram_admin') &&
                      <li onClick={this.closeSideBar} className={`${path.includes("telegram-groups") ? "mm-active" : ""}`}>
                        <Link className={`d-flex align-items-center py-0 pl-1 ${path.includes("telegram-groups") ? "mm-active" : ""}`}
                          onClick={() => this.props.onClick()} to="/admin/telegram-groups"
                        >
                          <span className='menu-icon'>💬</span>
                          <span className="nav-text">Telegram групи</span>
                        </Link>
                      </li>
                    }
                    <li onClick={this.closeSideBar} className={`${path === "admin-settings" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "admin-settings" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/admin-settings"
                      >
                        <span className='menu-icon'>
                          {String.fromCodePoint('0x1F310')}
                        </span>
                        <span className="nav-text">Зони</span>
                      </Link>
                    </li>
                    <li onClick={this.closeSideBar} className={`${path === "support" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "support" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/support"
                      >
                        <span className='menu-icon'>
                          {String.fromCodePoint('0x2753')}
                        </span>
                        <span className="nav-text">Support</span>
                      </Link>
                    </li>
                    <li onClick={this.closeSideBar} className={`${path === "delivery_users" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "delivery_users" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/delivery_users"
                      >
                        <span className='menu-icon'>
                          {String.fromCodePoint('0x1F695')}
                        </span>
                        <span className="nav-text">Кур'єри</span>
                      </Link>
                    </li>
                  </>}
                {userRole === 'restaurateur' &&
                  <>
                    {!!currentRestaurant &&
                      <>
                        <li>
                          <a className='d-flex align-items-center py-0 pl-1 has-arrow ai-icon mm-active' href="#">
                            <span className='menu-icon'>
                              {String.fromCodePoint('0x1F3EC')}
                            </span>
                            <span className="nav-text">{currentRestaurant.name}</span>
                          </a>
                          <ul>
                            {restaurants.map((r, i) =>
                              <Fragment key={i}>
                                <li className={`${currentRestaurant.slug === r.slug ? "mm-active" : ""}`}
                                  onClick={() => this.saveRestaurantToLocalStorage(r)}>
                                  <Link to={window.location.pathname}
                                    className={`${currentRestaurant.slug === r.slug ? "mm-active" : ""}`}>
                                    <span className="nav-text"><b>{r.name}</b></span>
                                  </Link>
                                </li>
                              </Fragment>)}
                          </ul>
                        </li>
                        {!isWorker &&
                          <li>
                            <a className={`${Object.keys(settings()).includes(window.location.pathname.split('/')[1]) && "mm-active"} has-arrow ai-icon d-flex align-items-center py-0 pl-1`} href="#">
                              <span className='menu-icon'>
                                {String.fromCodePoint('0x2699')}
                              </span>
                              <span className="nav-text">Налаштування</span>
                            </a>
                            <ul>
                              {Object.keys(settings()).map((r, i) =>
                                <Fragment key={i}>
                                  <li className={`${window.location.pathname.includes(r) ? "mm-active" : ""}`}
                                    onClick={this.closeSideBar}
                                  >
                                    <Link to={`/settings/${r}`}
                                      className={`${window.location.pathname.includes(r) ? "mm-active" : ""}`}>
                                      <span className="nav-text">{settings()[r]}</span>
                                    </Link>
                                  </li>
                                </Fragment>)}
                            </ul>
                          </li>}
                        <li onClick={this.closeSideBar} className={`${path === "dashboard" ? "mm-active" : ""}`}>
                          <Link className={`d-flex align-items-center py-0 pl-1 ${path === "dashboard" ? "mm-active" : ""}`}
                            onClick={() => this.props.onClick()} to="/dashboard"
                          >
                            <span className='menu-icon'>
                              {String.fromCodePoint('0x1F4CA')}
                            </span>
                            <span className="nav-text">Панель замовлень</span>
                          </Link>
                        </li>
                        <li onClick={this.closeSideBar} className={`${path === "restaurant-orders" ? "mm-active" : ""}`}>
                          <Link className={`d-flex align-items-center py-0 pl-1 ${path === "restaurant-orders" ? "mm-active" : ""}`}
                            onClick={() => this.props.onClick()} to="/restaurant-orders"
                          >
                            <span className='menu-icon'>
                              {String.fromCodePoint('0x1F5C3')}
                            </span>
                            <span className="nav-text">Архів замовлень</span>
                          </Link>
                        </li>
                        {restaurantHasQRpay() &&
                          <li onClick={this.closeSideBar} className={`${path === "paychecks" ? "mm-active" : ""}`}>
                            <Link className={`d-flex align-items-center py-0 pl-1 ${path === "paychecks" ? "mm-active" : ""}`}
                              onClick={() => this.props.onClick()} to="/paychecks"
                            >
                              <span className='menu-icon'>
                                {String.fromCodePoint('0x1F9FE')}
                              </span>
                              <span className="nav-text">Рахунки/оплата</span>
                            </Link>
                          </li>}
                        <li onClick={this.closeSideBar} className={`${path === "stop_list" && "mm-active"}`}>
                          <Link className={`d-flex align-items-center py-0 pl-1 ${path === "stop_list" && "mm-active"}`}
                            onClick={() => this.props.onClick()} to="/stop_list"
                          >
                            <span className='menu-icon'>
                              {String.fromCodePoint('0x1F6AB')}
                            </span>
                            <span className="nav-text">Стоп-лист</span>
                          </Link>
                        </li>
                        {!!currentRestaurant.management_roles &&
                          currentRestaurant.management_roles.role === 'owner' &&
                          <li onClick={this.closeSideBar} className={`${path === "analytics" && "mm-active"}`}>
                            <Link className={`d-flex align-items-center py-0 pl-1 ${path === "analytics" && "mm-active"}`}
                              onClick={() => this.props.onClick()} to="/analytics"
                            >
                              <span className='menu-icon'>
                                {String.fromCodePoint('0x1F4C8')}
                              </span>
                              <span className="nav-text">Аналітика</span>
                            </Link>
                          </li>}
                        {!isWorker &&
                          <>
                            <li onClick={this.closeSideBar} className={`${path === "restaurant_guests" && "mm-active"}`}>
                              <Link className={`d-flex align-items-center py-0 pl-1 ${path === "restaurant_guests" && "mm-active"}`}
                                onClick={() => this.props.onClick()} to="/restaurant_guests"
                              >
                                <span className='menu-icon'>
                                  {String.fromCodePoint('0x1F46B')}
                                </span>
                                <span className="nav-text">База гостей</span>
                              </Link>
                            </li>
                            {currentRestaurant && Object.values(currentRestaurant.tables).filter((t) => t.is_terminal).length > 0 &&
                              <li onClick={this.closeSideBar} className={`${path === "kiosk" && "mm-active"}`}>
                                <Link className={`d-flex align-items-center py-0 pl-1 ${path === "kiosk" && "mm-active"}`}
                                  onClick={() => this.props.onClick()} to="/kiosk"
                                >
                                  <span className='menu-icon'>
                                    {String.fromCodePoint('0x1F4F1')}
                                  </span>
                                  <span className="nav-text">Кіоск</span>
                                </Link>
                              </li>}
                          </>}
                      </>}
                  </>}
                {userRole === 'delivery_user' &&
                  <>
                    <li onClick={this.closeSideBar} className={`${path === "deliveries" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "deliveries" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/deliveries"
                      >
                        <span className='menu-icon'>
                          {String.fromCodePoint('0x1F4CA')}
                        </span>
                        <span className="nav-text">Замовлення</span>
                      </Link>
                    </li>
                    <li onClick={this.closeSideBar} className={`${path === "my-deliveries" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "my-deliveries" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/my-deliveries"
                      >
                        <span className='menu-icon'>
                          {String.fromCodePoint('0x1F5C3')}
                        </span>
                        <span className="nav-text">Мої доставки</span>
                      </Link>
                    </li>
                    <li onClick={this.closeSideBar} className={`${path === "delivery_settings" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "delivery_settings" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/delivery_settings"
                      >
                        <span className='menu-icon'>
                          {String.fromCodePoint('0x2699')}
                        </span>
                        <span className="nav-text">Налаштування</span>
                      </Link>
                    </li>
                  </>}
                {userRole === 'operator' &&
                  <>
                    <li onClick={this.closeSideBar} className={`${path === "manager_orders" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "manager_orders" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/manager_orders"
                      >
                        <span className='menu-icon'>🛍️</span>
                        <span className="nav-text">Замовлення</span>
                      </Link>
                    </li>
                    <li onClick={this.closeSideBar} className={`${path === "admin-settings" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "admin-settings" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/admin-settings"
                      >
                        <span className='menu-icon'>
                          {String.fromCodePoint('0x1F310')}
                        </span>
                        <span className="nav-text">Зони</span>
                      </Link>
                    </li>
                    <li onClick={this.closeSideBar} className={`${path === "my-deliveries" ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path === "my-deliveries" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/my-deliveries"
                      >
                        <span className='menu-icon'>
                          {String.fromCodePoint('0x1F5C3')}
                        </span>
                        <span className="nav-text">Мої доставки</span>
                      </Link>
                    </li>
                  </>}
                {userRole === 'telegram_admin' && userRole !== 'admin' && userRole !== 'manager' &&
                  <>
                    <li onClick={this.closeSideBar} className={`${path.includes("telegram-groups") ? "mm-active" : ""}`}>
                      <Link className={`d-flex align-items-center py-0 pl-1 ${path.includes("telegram-groups") ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()} to="/admin/telegram-groups"
                      >
                        <span className='menu-icon'>💬</span>
                        <span className="nav-text">Telegram групи</span>
                      </Link>
                    </li>
                  </>}
              </MM>
              {(userRole === 'manager' || userRole === 'admin') &&
                <div className="plus-box">
                  <Button className="btn btn-success btn-rounded d-block mr-auto ml-auto"
                    onClick={() => history.push('/about')}
                  >
                    Створити заклад
                  </Button>
                </div>}
            </PerfectScrollbar>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SideBar);
